import { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Stepper } from "../core/Stepper";
import { Switch } from "../core/Switch";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { HouseIcon } from "../core/icons/Icons";
import { useStyles } from "../../useStyles";

export const IncreaseExpectedHousingUnitsForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, getFieldProps } =
        useFormModel<ChangeNames.INCREASE_EXPECTED_HOUSING_UNITS>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HouseIcon />}
                useSwitch={
                    <Switch
                        checked={values.increaseExpectedHousingUnits.value.installed}
                        {...getFieldProps("adjustableLoadElectricBoiler.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseExpectedHousingUnits.value.installed = checked;
                                values.increaseExpectedHousingUnits.value.units = checked
                                    ? 1
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseExpectedHousingUnits.value.installed}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Anzahl der Wohneinheiten
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 28 }}>
                            Geben Sie hier die Anzahl der Wohneinheiten ein.
                        </p>
                    </Fragment>
                }
                detail={
                    <Fragment>
                        <Stepper
                            allowNegative={false}
                            value={values.increaseExpectedHousingUnits.value.units || 0}
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.increaseExpectedHousingUnits.value.units =
                                        v.floatValue ||
                                        values.increaseExpectedHousingUnits.value.units;
                                })
                            }
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
